import { createRef } from 'react';

import styled from 'styled-components';

import { AnimatedScreenProps } from './AnimatedScreen.decl';

import { Box, Flex, Typography } from '@aircall/tractor';
import { Player } from '@lottiefiles/react-lottie-player';

const CustomBox = styled(Box)<{ order: number }>`
  order: ${({ order }) => order};
  text-align: center;
`;

export function AnimatedScreen({
  title,
  children,
  imgSrc,
  shouldShowImgFirst = true,
  dataTest,
}: AnimatedScreenProps) {
  const playerRef = createRef<Player>();

  return (
    <Flex
      alignItems='center'
      height='100%'
      paddingTop='100px'
      px={['l', 'xl', 'xxl']}
      flexDirection='column'
      backgroundColor='grey.light'
      data-test={dataTest}
    >
      {imgSrc && (
        <Player ref={playerRef} autoplay loop controls src={imgSrc} style={{ width: '730px' }} />
      )}
      <CustomBox maxWidth={730} order={shouldShowImgFirst ? 2 : -1}>
        <Typography as='h2' variant='displayL' margin={0} mb='m' data-test='animated-screen-title'>
          {title}
        </Typography>
        <Typography
          as='p'
          variant='body'
          mb='xl'
          whiteSpace='pre-line'
          data-test='animated-screen-content'
        >
          {children}
        </Typography>
      </CustomBox>
    </Flex>
  );
}
